import PropTypes from 'prop-types';
import { convertDate } from '../Organisms/OrganismRemboursement/OrganismRemboursement';

SoinsDateActe.prototype = {
  lines: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
}

SoinsDateActe.defaultProps = {
  lines: [],
  className: '',
}

const getMinMaxDateActe = (lines) => {
  if (!lines.length) return null;

  let minDate = +new Date(lines[0].dateActe.value)
  let maxDate = +new Date(lines[0].dateActe.value);

  lines.forEach((line) => {
    const currentDateActe = +new Date(line.dateActe.value);

    if (currentDateActe < minDate) {
      minDate = currentDateActe;
    }

    if (currentDateActe > maxDate) {
      maxDate = currentDateActe;
    }
  })

  return {
    minDate: new Date(minDate).toLocaleDateString('fr'),
    maxDate: new Date(maxDate).toLocaleDateString('fr'),
    isDifferent: minDate !== maxDate,
  }
}

export function SoinsDateActe(props) {
  const datePeriod = getMinMaxDateActe(props.lines ?? []);
  const soinsHasDifferentDates = datePeriod && datePeriod.isDifferent && datePeriod.maxDate && datePeriod.minDate;

  return (
    <>
      {!!(soinsHasDifferentDates) && (
        <span className="at-text-soins-date">
                      {' '}
          • Soins du {datePeriod.minDate} au {datePeriod.maxDate}
                    </span>
      ) }

      {datePeriod && !datePeriod.isDifferent && !!(datePeriod.minDate) && (
        <span className="at-text-soins-date">
                      {' '}
          • Soins du {datePeriod.minDate}
                    </span>
      )}
    </>
  )
}